@for (menu of menuItems; track menu) {
  <a [id]="menu.id"
    class='parent'
    slot="primary-items"
    [routerLink]="menu.url"
    [attr.active]="isActive(menu) ? 'active' : null"
    (click)="onMenuClicked(null, menu, $event)">
    {{menu.title}}
  </a>
  @if (menu.subItems && menu.subItems.length) {
    <c-navigation slot="sub" [caption]="menu.title"
      [attr.active]="isActive(menu) ? 'active' : null" [target]="menu.url">
      @for (subMenu of menu.subItems; track subMenu) {
        <a
          slot="primary-items"
          [routerLink]="subMenu.url"
          [id]="subMenu.id"
        (click)="onMenuClicked(menu, subMenu, $event)" [attr.class]="isActive(subMenu) ? 'active' : ''">{{subMenu.title}}</a>
      }
    </c-navigation>
  }
}

<div slot="secondary-items">
  <cal-product-search></cal-product-search>
</div>
